module.exports = __webpack_public_path__ + "img/toggle_qrcode.d7d5ce82.png";